<script setup lang="ts">
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog';

type Props = {
    title: string;
    description: string;
    confirmButtonText: string;
};

const { title, description, confirmButtonText } = defineProps<Props>();
const isConfirmDialogOpen = defineModel<boolean>('isConfirmDialogOpen');

const emit = defineEmits<{
    (e: 'confirm'): void;
}>();

const handleConfirm = (event: MouseEvent) => {
    event.stopPropagation();
    emit('confirm');
    isConfirmDialogOpen.value = false;
};
</script>

<template>
    <Dialog v-model:open="isConfirmDialogOpen">
        <DialogContent class="sm:rounded-2xl">
            <DialogHeader>
                <DialogTitle>{{ title }}</DialogTitle>
            </DialogHeader>
            <DialogDescription>
                {{ description }}
            </DialogDescription>
            <slot />
            <DialogFooter>
                <Button variant="destructive" @click="handleConfirm">
                    {{ confirmButtonText }}
                </Button>
                <Button
                    variant="secondary"
                    @click="isConfirmDialogOpen = false"
                >
                    Cancel
                </Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>
